<template>
  <div class="retail-hotel-card-container">
    <div class="retail-hotel-card-image-container">
      <ImageSlider
        :hotelid="parseInt(hotel.id)"
        :images="hotel.images"
      />
    </div>
    <div class="retail-hotel-info">
      <div class="retail-hotel-details">
        <div class="retail-hotel-title">
          <h4>{{ hotel.name }}</h4>
        </div>
        <p>{{ hotel.fullAddress }}</p>
        <p v-if="hotel.directions">
          {{ hotel.directions.distance.text }} to {{ this.$store.state.hotel.venue }}
        </p>
        <div
          v-if="hotel.reviews!=0"
          class="retail-hotel-rating"
        >
          <p class="rate">
            {{ hotel.rating ? hotel.rating.toFixed(1) : '0.0' }}
          </p>
          <p class="review-count small">
            {{ hotel.reviews }} {{ $t('h4h.userReviews') }}
          </p>
        </div>
      </div>
      <div class="retail-hotel-purchasing">
        <div class="retail-hotel-pricing">
          <span class="price">
            <CurrencyConvert
              :amount="(price / hotel.stayDuration)*rate"
              :usd="price / hotel.stayDuration"
              :currency="currency"
            />
          </span>
          <span class="per-night">{{ $t('h4h.perNight') }}</span>
          <span class="total-price">
            <CurrencyConvert
              :amount="price*rate"
              :usd="price"
              :currency="currency"
            />
            {{ $t('h4h.contractedTotal', {
              checkIn,
              checkOut
            }) }}
          </span>
        </div>
        <div class="retail-hotel-show-btn">
          <div
            class="btn btn-secondary room-select-btn"
            @click="selectSpecifiedHotel(hotel)"
          >
            {{ $t('h4h.chooseRoom') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global locale */
/* eslint-disable vue/prop-name-casing */
import ImageSlider from '../../image_slider'
import Hotel from '../../../classes/hotel'
import { CurrencyConvert } from '../../../default/currency_convert'
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import {trackHotelIndex, trackHotelOverview} from './shared_hotel_card_functions'

export default {
  components: {
    ImageSlider,
    CurrencyConvert,
  },
  props: {
    id: {
      default: null,
      type: Number
    },
    hotel: {
      default: null,
      type: Hotel
    },
    rate: {
      default: 1,
      type: Number
    },
    currency: {
      default: 'USD',
      type: String
    }
  },

  data() {
    return {
      address: String
    }
  },

  computed: {
    ...mapGetters('hotel', ['getLowestValue', 'getTBD']),
    price() {
      return this.getLowestValue(this.hotel.id)
    },
    checkIn(){
      moment.locale(locale)
      return moment(this.hotel.checkIn).format('L')
    },
    checkOut(){
      moment.locale(locale)
      return moment(this.hotel.checkOut).format('L')
    },
    hotelLocation(){
      return {lat:this.hotel.latitude, lng:this.hotel.longitude}
    },
  },

  methods: {
    ...mapMutations('hotel', ['selectHotel', 'deselectHotel', 'setRetailHotelStatus']),

    selectSpecifiedHotel(hotel){
      this.selectHotel(hotel)
      this.setRetailHotelStatus(true)
      this.manipulateHistory(hotel)

      trackHotelOverview(hotel)
    },

    manipulateHistory(hotel){
      window.history.pushState(hotel.id, null, `hotels#${hotel.id}`)
      window.addEventListener('popstate', (e)=>{
        if(e.state !== null) {
          this.selectHotel(hotel)
          trackHotelOverview(hotel)
        } else {
          this.selectHotel(null)
          trackHotelIndex()
        }
      })
    },

  }
}
</script>
